import {ApolloError} from '@apollo/client'
import {MFA_REQUIRED_ERROR} from './common/types/constants'

export const isMFAError = (error: ApolloError) =>
  error.networkError &&
  'result' in error.networkError &&
  error.networkError?.result.includes(MFA_REQUIRED_ERROR)
